import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getProjectResources({ uuid }) {
      const res = getState().find(({ project }) => project.uuid === uuid);

      return res ? res.projectResources : [];
    },
    isProjectResourcesRetrievalRequestFailure({ uuid }) {
      const res = getState().find(({ project }) => project.uuid === uuid);

      return res ? res.request.isFailure : false;
    },
    isProjectResourcesRetrievalRequestPending({ uuid }) {
      const res = getState().find(({ project }) => project.uuid === uuid);

      return res ? res.request.isPending : false;
    },
    isProjectResourcesRetrievalRequestSuccess({ uuid }) {
      const res = getState().find(({ project }) => project.uuid === uuid);

      return res ? res.request.isSuccessful : false;
    },
  };
}

export { createSelector };
